<header>
  <h3  >Dziękujemy! To już koniec pytań.</h3>
  <h3  >Każdy z naszych tynków będzie dla ciebie odpowiedni.</h3>
  <h3  >Zastanów się, jaka właściwość tynku jest dla Ciebie najważniejsza i wybierz jedną z opcji:</h3>
</header>
<main class="questionnaire">
  <ul>
    <li (click)="onQuestion4Click(Odpornosc.zabrudzenia)"
      [class.selected]="project.ankieta.pytanie4==Odpornosc.zabrudzenia"><span  >ODPORNOŚĆ NA ZABRUDZENIA</span></li>
    <li (click)="onQuestion4Click(Odpornosc.korozjaBiologiczna)"
      [class.selected]="project.ankieta.pytanie4==Odpornosc.korozjaBiologiczna"><span  >ODPORNOŚĆ NA ZAGRZYBIENIE I
        KOROZJĘ BIOLOGICZNĄ</span></li>
  </ul>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
